import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import Container from '@mui/material/Container'
import ListItemText from '@mui/material/ListItemText'
import ListItem from '@mui/material/ListItem'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import LoadingButton from '@mui/lab/LoadingButton'

import { deepOrange, green } from '@mui/material/colors'

import BorderLinearAndFacebookCircularProgress from '../Progress/BorderLinearAndFacebookCircularProgress'
import _ from 'lodash'
import { useTranslate } from 'react-admin'
import { IMPORT_FIELDS } from '../../providers/localization/constant'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction='up' ref={ref} {...props} />
})

const UploadProgressDialog = ({
  open,
  progress,
  importResultLists,
  handleClose,
}: {
  open: boolean
  progress: number
  importResultLists: object[]
  handleClose: () => void
}): JSX.Element => {
  const processing = progress < 100
  const last = _.head(importResultLists)
  const translate = useTranslate()

  return (
    <Dialog fullScreen open={open} TransitionComponent={Transition}>
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
            Import
          </Typography>
          <LoadingButton
            color='secondary'
            onClick={handleClose}
            loading={processing}
            loadingPosition='start'
            startIcon={<CloseIcon />}
            variant='contained'
          >
            <span>{processing ? 'processing' : 'close'}</span>
          </LoadingButton>
        </Toolbar>
      </AppBar>
      <Container>
        <div style={{ padding: '16px 0px', display: processing ? 'block' : 'none' }}>
          <BorderLinearAndFacebookCircularProgress value={progress} />
          <Typography variant='body1' sx={{ mt: 2 }}>
            {`ID: ${_.get(last, ['record', 'id'], '')} : `}
            {_.get(last, ['isSuccess'])
              ? _.get(last, ['record', 'prod_name_th'])
              : `Error: ${_.get(last, ['errorMessage'])}`}
          </Typography>
        </div>
        {processing && <Divider />}
        {!processing && (
          <>
            <div style={{ padding: '16px 0px', display: 'flex', alignItems: 'center' }}>
              <Avatar sx={{ bgcolor: green[500] }}>
                <CheckIcon />
              </Avatar>
              <Typography color={'success'} variant='h4' sx={{ ml: 1 }}>
                {translate(`${IMPORT_FIELDS}.import_status.success`)}
              </Typography>
            </div>
            <Divider />
          </>
        )}
        <List>
          {_.map(
            _.filter(importResultLists, (imr) => !_.get(imr, ['isSuccess'])),
            (imr) => {
              return (
                <>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar
                        sx={{ bgcolor: _.get(imr, 'isSuccess') ? green[500] : deepOrange[500] }}
                      >
                        {_.get(imr, 'isSuccess') ? <CheckIcon /> : <CloseIcon />}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={`ID: ${_.get(imr, ['record', 'id'], '')}`}
                      secondary={
                        _.get(imr, ['isSuccess'])
                          ? _.get(imr, ['record', 'prod_name_th'])
                          : `Error: ${_.get(imr, ['errorMessage'])}`
                      }
                    />
                  </ListItem>
                  <Divider />
                </>
              )
            },
          )}
          {/* <ListItem>
            <ListItemText primary='Default notification ringtone' secondary='Tethys' />
          </ListItem> */}
        </List>
      </Container>
    </Dialog>
  )
}

export default UploadProgressDialog
